/**
 * Deterministic id generation. Ids must be stable across a save/load cycle and
 * identical for identical seeds, so they are drawn from a counter rather than
 * anything time- or random-based.
 */
export class IdGenerator {
  private counters = new Map<string, number>();

  next(prefix: string): string {
    const n = (this.counters.get(prefix) ?? 0) + 1;
    this.counters.set(prefix, n);
    return `${prefix}_${n}`;
  }

  getState(): Record<string, number> {
    return Object.fromEntries(this.counters);
  }

  setState(state: Record<string, number>): void {
    this.counters = new Map(Object.entries(state));
  }
}
